var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluePattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 166,
    viewBox: "0 0 446 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.667 13.67V41.003H164V13.67H136.667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.333 82.0001V136.667L131 109.333L158.333 82.0001Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 164V109.333L158.333 136.667L131 164Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.333 25.127C72.107 25.127 75.166 28.186 75.166 31.96C75.166 35.734 72.107 38.793 68.333 38.793C64.559 38.793 61.5 35.734 61.5 31.96C61.5 28.186 64.559 25.127 68.333 25.127Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.166 112.75C116.166 108.976 113.107 105.917 109.333 105.917C105.559 105.917 102.5 108.976 102.5 112.75C102.5 116.524 105.559 119.583 109.333 119.583C113.107 119.583 116.166 116.524 116.166 112.75Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5 112.75C102.5 108.976 99.4407 105.917 95.667 105.917C91.8932 105.917 88.834 108.976 88.834 112.75C88.834 116.524 91.8932 119.583 95.667 119.583C99.4407 119.583 102.5 116.524 102.5 112.75Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.833 112.75C88.833 108.976 85.7738 105.917 82 105.917C78.2262 105.917 75.167 108.976 75.167 112.75C75.167 116.524 78.2262 119.583 82 119.583C85.7738 119.583 88.833 116.524 88.833 112.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4969 75.7544C93.1597 70.4172 84.5063 70.4172 79.1691 75.7544C73.8318 81.0916 73.8318 89.745 79.1691 95.0823C84.5063 100.42 93.1597 100.42 98.4969 95.0823C103.834 89.745 103.834 81.0916 98.4969 75.7544Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 5.34058e-05H390.667V54.6671C360.475 54.6671 336 30.1921 336 5.34058e-05Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.667 27.3331V7.62939e-05H445.334V27.3331C445.334 42.4291 433.096 54.6661 418.001 54.6661C402.904 54.6671 390.667 42.4291 390.667 27.3331Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 41.0001H281.33V6.10352e-05H322.33V13.6701L308.67 13.6701V27.3301H295V41.0001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 54.67H295V41H308.67V27.33H322.33V13.67H336V54.67Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.592 71.5315C382.815 57.5847 366.825 50.9618 352.879 56.7389C338.932 62.516 332.309 78.5054 338.086 92.4522C343.863 106.399 359.853 113.022 373.799 107.245C387.746 101.468 394.369 85.4783 388.592 71.5315Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.25 82.0001C387.25 68.7911 376.542 58.0831 363.333 58.0831C350.124 58.0831 339.416 68.7911 339.416 82.0001C339.416 95.2091 350.124 105.917 363.333 105.917C376.542 105.917 387.25 95.2091 387.25 82.0001Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.416 82.0001C380.416 72.5654 372.768 64.9171 363.333 64.9171C353.898 64.9171 346.25 72.5654 346.25 82.0001C346.25 91.4348 353.898 99.0831 363.333 99.0831C372.768 99.0831 380.416 91.4348 380.416 82.0001Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.583 82.0001C373.583 76.3392 368.994 71.7501 363.333 71.7501C357.672 71.7501 353.083 76.3392 353.083 82.0001C353.083 87.661 357.672 92.2501 363.333 92.2501C368.994 92.2501 373.583 87.661 373.583 82.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.667 109.333V54.6671H445.333V82.0001H418L390.667 109.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418 109.333H390.667L418 82.0001V109.333Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 81.9991V54.6661L308.667 54.6661V81.9991H336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418 164C402.907 164 390.667 151.76 390.667 136.667H445.334C445.333 151.76 433.093 164 418 164Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.333 136.667H390.666C390.666 121.574 402.906 109.334 417.999 109.334C433.093 109.333 445.333 121.574 445.333 136.667Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.667 68.3331C308.667 60.785 302.548 54.6661 295 54.6661C287.452 54.6661 281.333 60.785 281.333 68.3331C281.333 75.8812 287.452 82.0001 295 82.0001C302.548 82.0001 308.667 75.8812 308.667 68.3331Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.667 109.333V82.0001H281.334V109.333H308.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.667 95.6671V82.0001H336V95.6671C336 103.215 329.881 109.334 322.333 109.334C314.785 109.333 308.667 103.215 308.667 95.6671Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 109.333H390.667V164L336 109.333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.337 117.337L281.333 109.333H308.666C301.116 109.333 294.283 112.391 289.337 117.337Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 136.667C336 121.574 323.76 109.334 308.667 109.334H336V136.667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 164L327.996 155.997C332.942 151.051 336 144.218 336 136.667V164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.996 155.997L289.336 117.337C294.282 112.391 301.115 109.333 308.666 109.333C323.759 109.333 335.999 121.573 335.999 136.666C336 144.218 332.942 151.051 327.996 155.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 164H281.333V109.333L336 164Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.33 -1.52588e-05V13.67H336V-1.52588e-05H322.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.67 13.6701V27.3301H322.33V13.6701H308.67Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 27.3301V41.0001H308.67V27.3301H295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.33 41V54.67H295V41H281.33Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.666 163.999H281.333V109.332H226.666V163.999Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.334 109.333H226.667V82.0001H199.334V109.333Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.193 136.839C248.743 135.63 241.722 140.69 240.513 148.14C239.304 155.591 244.364 162.611 251.814 163.82C259.265 165.03 266.285 159.97 267.495 152.519C268.704 145.068 263.644 138.048 256.193 136.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.667 123C267.667 115.452 261.548 109.333 254 109.333C246.452 109.333 240.333 115.452 240.333 123C240.333 130.548 246.452 136.667 254 136.667C261.548 136.667 267.667 130.548 267.667 123Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 157.167C213 153.393 216.059 150.334 219.833 150.334C223.607 150.334 226.666 153.393 226.666 157.167C226.666 160.941 223.607 164 219.833 164C216.059 164 213 160.941 213 157.167Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.333 157.167C199.333 153.393 202.392 150.334 206.166 150.334C209.94 150.334 212.999 153.393 212.999 157.167C213 160.941 209.941 164 206.167 164C202.393 164 199.333 160.941 199.333 157.167Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.667 157.167C185.667 153.393 188.726 150.334 192.5 150.334C196.274 150.334 199.333 153.393 199.333 157.167C199.333 160.941 196.274 164 192.5 164C188.726 164 185.667 160.941 185.667 157.167Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 157.167C172 153.393 175.059 150.334 178.833 150.334C182.607 150.334 185.666 153.393 185.666 157.167C185.666 160.941 182.607 164 178.833 164C175.059 164 172 160.941 172 157.167Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 116.167C213 112.393 216.059 109.334 219.833 109.334C223.607 109.334 226.666 112.393 226.666 116.167C226.666 119.941 223.607 123 219.833 123C216.059 123 213 119.941 213 116.167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.333 116.167C199.333 112.393 202.392 109.334 206.166 109.334C209.94 109.334 212.999 112.393 212.999 116.167C212.999 119.941 209.94 123 206.166 123C202.393 123 199.333 119.941 199.333 116.167Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.667 116.167C185.667 112.393 188.726 109.334 192.5 109.334C196.274 109.334 199.333 112.393 199.333 116.167C199.333 119.941 196.274 123 192.5 123C188.726 123 185.667 119.941 185.667 116.167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 116.167C172 112.393 175.059 109.334 178.833 109.334C182.607 109.334 185.666 112.393 185.666 116.167C185.666 119.941 182.607 123 178.833 123C175.059 123 172 119.941 172 116.167Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.996 127.004C203.659 121.667 195.005 121.667 189.668 127.004C184.331 132.342 184.331 140.995 189.668 146.332C195.005 151.669 203.659 151.669 208.996 146.332C214.333 140.995 214.333 132.342 208.996 127.004Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.667 13.6671C390.667 6.11898 384.548 4.57764e-05 377 4.57764e-05C369.452 4.57764e-05 363.333 6.11898 363.333 13.6671C363.333 21.2151 369.452 27.334 377 27.334C384.548 27.334 390.667 21.2151 390.667 13.6671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.148 13.6671H262.481V68.3331H235.148C220.052 68.3331 207.815 56.0961 207.815 41.0001C207.815 25.9041 220.052 13.6671 235.148 13.6671Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.948 27.4455C229.466 26.4439 222.589 31.697 221.587 39.1787C220.586 46.6603 225.839 53.5374 233.32 54.539C240.802 55.5406 247.679 50.2875 248.681 42.8059C249.682 35.3242 244.429 28.4472 236.948 27.4455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 164H158.333V136.667L131 164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.667 164H109.334C109.334 148.904 97.097 136.667 82.001 136.667C66.905 136.667 54.667 148.904 54.667 164Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.083 164C58.083 150.812 68.812 140.083 82 140.083C95.188 140.083 105.917 150.812 105.917 164",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.917 164C64.917 154.58 72.581 146.917 82 146.917C91.419 146.917 99.083 154.58 99.083 164",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.75 164H92.25C92.25 158.348 87.652 153.75 82 153.75C76.348 153.75 71.75 158.348 71.75 164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.583 150.333V95.6661C22.487 95.6671 10.25 107.904 10.25 123C10.25 138.096 22.487 150.333 37.583 150.333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.583 146.917C24.395 146.917 13.666 136.188 13.666 123C13.666 109.812 24.395 99.0831 37.583 99.0831",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.583 140.083C28.164 140.083 20.5 132.42 20.5 123C20.5 113.58 28.164 105.917 37.583 105.917",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.583 133.25V112.75C31.931 112.75 27.333 117.348 27.333 123C27.333 128.652 31.932 133.25 37.583 133.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 31.96L0 59.294H27.333L0 31.96Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 86.627L0 59.294H27.333L0 86.627Z",
    fill: "#1DA1F2",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePattern);
export default __webpack_public_path__ + "static/media/bluePattern.9db6b28b3edbbade54e91747c88493ff.svg";
export { ForwardRef as ReactComponent };